import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAdminPanel = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 40,
			height: 40,
			rx: 4,
			fill: "#161957"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M31.7079 12.2583L28.7985 15.1677C28.5852 15.381 28.24 15.381 28.0273 15.1677L24.8337 11.9736C24.6205 11.7604 24.621 11.4151 24.8337 11.2024L27.7442 8.29302C26.9478 8.05684 26.116 7.96194 25.287 8.01375C21.89 8.34211 19.4023 11.3616 19.7306 14.7586C19.7715 15.1797 19.855 15.5959 19.981 16L9.25768 25.4944C7.719 26.8515 7.57173 29.199 8.92878 30.7377C8.9806 30.7966 9.03459 30.8539 9.09023 30.9095C10.5405 32.362 12.8936 32.3637 14.3461 30.9134C14.4017 30.8577 14.4552 30.8004 14.5075 30.7421L24.0014 20.021C25.0143 20.3313 26.0882 20.3892 27.1284 20.1884C29.3712 19.7406 31.1788 18.0836 31.8191 15.8882C32.0924 14.6888 32.0542 13.4392 31.7079 12.2583Z",
			fill: "url(#paint0_linear_11215_201798)"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_11215_201798",
			x1: 9.92935,
			y1: 31.0775,
			x2: 32.0831,
			y2: 7.91804,
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("stop", {
					offset: .00183952,
					stopColor: "#53BCDE"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .368179,
					stopColor: "#767CFF"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .645971,
					stopColor: "#AC8EFF"
				})
			]
		}) })
	]
});
export default SvgAdminPanel;
